import BaseAPI from '@/apis/base/baseApi';
export default class FRApi extends BaseAPI {
  apiName = 'FR';
}
